import { SHBox, SHStack, SHTypography } from "@components/design-systems";
import { FieldTitle } from "@layouts/platform-analysis/transfer-select-feature-list/components/field-title";
import {
  BusinessMetricCategories,
  BusinessMetricDTO,
} from "@models/platform-analysis/entities/steps/businessMetric";
import { useTheme } from "@mui/material";
import { updateBusinessMetricItemSelectionStore } from "@redux/slices/platform-analysis";
import { useAppDispatch } from "@redux/store";
import { memo } from "react";
import { AnalysisBusinessMetricItem } from "../metric";

type AnalysisBusinessMetricCategoryProps = {
  title?: JSX.Element | string;
  titleIcon?: JSX.Element;
  categoryData: BusinessMetricDTO[];
  categoryKey?: keyof BusinessMetricCategories;
};
export const AnalysisBusinessMetricCategory = memo(
  ({
    title,
    titleIcon,
    categoryData,
    categoryKey,
  }: AnalysisBusinessMetricCategoryProps) => {
    const { palette } = useTheme();
    const dispatch = useAppDispatch();

    const isSelectedAll = categoryData.every((metric) => metric.isSelected);

    const handleOnClickSelectAll = () => {
      if (!categoryKey) return;
      dispatch(
        updateBusinessMetricItemSelectionStore({
          isSelected: !isSelectedAll,
          category: categoryKey,
        }),
      );
    };

    return (
      <SHStack gap={2}>
        <SHStack direction={"row"} justifyContent={"space-between"}>
          <SHStack
            direction={"row"}
            justifyContent={"space-between"}
            spacing={0.5}
          >
            <SHBox>{titleIcon}</SHBox>
            <SHTypography
              sx={{
                marginTop: "auto !important",
                marginBottom: "auto !important",
              }}
              variant="subtitle1"
            >
              {title}
            </SHTypography>
          </SHStack>

          <FieldTitle
            actionText={`${!isSelectedAll ? "Select all" : "Deselect all"}`}
            handleOnClick={handleOnClickSelectAll}
            sx={{
              marginTop: "auto",
              marginBottom: "auto",
            }}
          />
        </SHStack>

        <SHBox
          sx={{
            border: `1px solid ${palette.secondary[100]}`,
            padding: "1%",
            display: "grid",
            gap: "10px",
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
          }}
        >
          {categoryData.map((metricData) => (
            <AnalysisBusinessMetricItem
              key={metricData.id}
              metricData={metricData}
              categoryKey={categoryKey}
            />
          ))}
        </SHBox>
      </SHStack>
    );
  },
);
